module.exports = __webpack_public_path__ + "img/logo-all-white-horizontal.bc940033.svg";